import { combineReducers } from 'redux';

import mealReducer from '../store/meal';
import teamReducer from '../store/team';
import eatingReducer from '../store/eating';
import ticketReducer from '../store/ticket';
import meetingsReducer from '../store/meetings';
import eventeatingReducer from '../store/eventeating';
import accountsReducer from '../store/accounts';

export default combineReducers({
  meal: mealReducer,
  meetings: meetingsReducer,
  eventeating: eventeatingReducer,
  eating: eatingReducer,
  ticket: ticketReducer,
  team: teamReducer,
  accounts: accountsReducer
});
